/**
 * @enum {number}
 * @description 游戏状态对应的常量枚举
 */
export const enum GameStateConst {
  /** 已下线 */
  Offline = 2,
  /** 资料待完善 */
  ToBeImprove = 3,
  /** 待审核 */
  ToBeExamine = 4,
  /** 审核未通过 */
  ExamineFail = 5,
  /** 审核中 */
  Examining = 6,
  /** 已上线 */
  Online = 7,
  /** 审核已通过 */
  ExamineSuccess = 8,
  /** 初审待提交 */
  FirstTrialToBeSubmit = 9,
  /** 待初审 */
  ToBeFirstTrial = 10,
  /** 初审中 */
  FirstTrial = 11,
  /** 初审未通过 */
  FirstTrialFail = 12,
  /** 初审已通过 */
  FirstTrialSuccess = 13,
  /** 停止对接 */
  StopDocking = 14
}

export const enum GameStateOnlineConst {
  /** 上线 */
  Online = 0,
  /** 未上线 */
  NotOnline = 1,
  /** 下线 */
  Offline = 2
}

/**
 * 合并后的游戏状态
 * @enum {number}
 * @description 仅前端范围使用，真实传递给后端的还是原始的游戏状态（即GameStateConst）
 */
export const enum MergedGameStateConst {
  /**
   * 初审未通过：合并了GameStateConst中的
   * ——初审未通过（FirstTrialFail：12）
   */
  FirstTrialFail = 12,
  /**
   * 待初审：合并了GameStateConst中的
   * ——初审待提交（FirstTrialToBeSubmit：9）
   * ——待初审（ToBeFirstTrial：10）
   * ——初审中（FirstTrial：11）
   */
  ToBeFirstTrial = 1,
  /**
   * 对接提审驳回（未上线）：合并了GameStateConst中的
   * ——审核未通过（ExamineFail：5）
   */
  ExamineFail = 2,
  /**
   * 对接提审阶段（未上线）：合并了GameStateConst中的
   * ——资料待完善（ToBeImprove：3）
   * ——待审核（ToBeExamine：4）
   * ——审核中（Examining：6）
   * ——审核已通过（ExamineSuccess：8）
   */
  DataExamine = 3,
  /**
   * 已上线：合并了GameStateConst中的
   * ——已上线（Online：7）
   */
  Online = 4,
  /**
   * 已上线（版更中）：合并了GameStateConst中的
   * ——待审核（ToBeExamine：4）
   * ——审核中（Examining：6）
   * ——审核已通过（ExamineSuccess：8）
   */
  DataExamineOnline = 6,
  /**
   * 已上线（版更驳回)：合并了GameStateConst中的
   * ——审核未通过（ExamineFail：5）
   */
  DataExamineOnlineFail = 7,
  /**
   * 已下线：合并了GameStateConst中的
   * ——已下线（StopDocking：2）
   */
  Offline = 5,
  /**
   * 初审已通过：原GameStateConst中的初审已通过（StopDocking：13）
   */
  FirstTrialSuccess = 13,
  /**
   * 停止对接：原GameStateConst中的停止对接（StopDocking：14）
   */
  StopDocking = 14
}

/**
 * @enum {number}
 * @description  游戏审核页面中的初审状态对应的枚举
 */
export enum GameReviewExamineStatus {
  /** 没开始 */
  NoStart = 0,
  /** 待提交 */
  ToBeSubmit = 1,
  /** 待审核 */
  ToBeExamine = 2,
  /** 审核中 */
  Examining = 3,
  /** 审核未通过 */
  ExamineFail = 4,
  /** 审核已通过 */
  ExamineSuccess = 5
}

/**
 * @enum {number}
 * @description 游戏审核页面中的资质审核状态对应的常量枚举
 */
export enum QualExamineExamineStatus {
  /** 没开始 */
  NoStart = -1,
  /** 待提交 */
  ToBeSubmit = 1,
  /** 待审核 */
  ToBeExamine = 2,
  /** 审核中 */
  Examining = 3,
  /** 审核未通过 */
  ExamineFail = 4,
  /** 审核已通过 */
  ExamineSuccess = 5
}

/**
 * @enum {number}
 * @description 是否有ip的常量枚举
 */
export const enum HaveIpConst {
  /** 有 */
  Have = 1,
  /** 没有 */
  NoHave = -1
}

/**
 * @enum {number}
 * @description ip类型的常量枚举
 */
export const enum IpTypeConst {
  /** 无(即还没开始选项) */
  None = 0,
  /** 传奇 */
  Legend = 1,
  /** 动漫 */
  Animation = 2,
  /** 其他 */
  Other = 3
}

/**
 * @enum {number}
 * @description 出包类型的常量枚举
 */
export const enum PackageTypeConst {
  /** 还没开始选 */
  None = 0,
  /** 7日内出包 */
  SevenDays = 1,
  /** 15日内出包 */
  FifteenDays = 2,
  /** 30日内出包 */
  ThirtyDays = 3,
  /** 具体日期 */
  SpecificDate = 4
}

/**
 * 是否暂存常量枚举
 * @enum {number}
 */
export const enum TempSaveConst {
  /** 是 */
  Yes = 1,
  /** 否 */
  No = -1
}

/**
 * @enum {number}
 * @description 预约素材审核状态常量枚举
 */
export const enum reservationMaterialExStatus {
  /** 审核未提交 */
  ExamineNotSubmitted = -3,
  /** 审核失败 */
  ExamineFail = -2,
  /** 未审核 */
  NotExamine = -1,
  /** 审核成功 */
  ExamineSuccess = 1,
  /** 审核中 */
  Examineing = -4,
  /** 第二次待审核 */
  ExamineSecondNotExamine = 2,
  /** 第二次已变更 */
  ExamineSecondChanged = 3,
  /** 第二次审核失败 */
  ExamineSecondFail = 4,
  /** 第二次审核成功 */
  ExamineSecondSuccess = 5
}

/**
 * @enum {number}
 * @description 预约素材上传内容类型常量枚举
 */
export const enum MATERIAL_UPLOAD_TYPE_CONST {
  /** 视频和图片 */
  VODEO_AND_IMAGE = 1,
  /** 只有视频 */
  ONLY_VIDEO = 2,
  /** 只有图片 */
  ONLY_IMAGE = 3
}

/**
 * @enum {number}
 * @description 预约素材五图方向常量枚举
 */
export const enum AtlasdIrectionTypeConst {
  /** 横图 */
  Horizontal = 1,
  /** 竖图 */
  Vertical = 2
}

/**
 * @enum VideoDirectTypeConst
 * 视频类型：【-1：视频类型还没确定； 1：横版；2：竖版】
 */
export const enum VideoDirectTypeConst {
  /** 视频类型还没确定 */
  NotDetermined = '-1',
  /** 横版 */
  Horizontal = '1',
  /** 竖版 */
  Vertical = '2'
}

/**
 * @enum {number}
 * @description 合作类型的常量枚举
 */
export const enum CooperationTypeConst {
  /** 专服 */
  SpecialService = 1,
  /** 混服 */
  MixedService = -1,
  /** 海外服 */
  OverseasService = 2
}

/**
 * @enum {number}
 * @description 折扣限制/专服性质的常量枚举
 */
export const enum DiscountLimitConst {
  /** 无(即还没开始选项) */
  None = 0,
  /** 小7自定 */
  X7SY = 1,
  /** 无折扣 */
  NoDiscount = 2,
  /** 不低于x折 */
  NotLessThanX = 3,
  /** 0.1折 */
  ZeroPointOne = 4,
  /** 内置0.1折 */
  FixedZeroPointOne = 5,
  /** 0.0x折单选框，选择范围0.01-0.09，默认为0.05 */
  DiscountLimitRadio = 6
}
/**
 * @enum {number}
 * @description 折扣选择/无折扣的常量枚举
 */
export const enum DiscountSelectConst {
  /** 折扣选择 */
  DiscountSelect = 1,
  /** 无折扣 */
  NoneDiscount = 2
}

/**
 * @enum {number}
 * @description 折扣类型/分成比例类型的常量枚举
 */
export const enum RadioTypeConst {
  /** 固定比例 */
  FixedRatio = 1,
  /** 阶梯分成 */
  StepRatio = 2
}

/**
 * @enum {number}
 * @description 针对专服游戏，分成比例的常量枚举
 */
export const enum ShareRatioConst {
  /** 默认比例 */
  DefaultRatio = 1,
  /** 自定比例 */
  CustomRatio = 2
}

/**
 * @enum {number}
 * @description 游戏包体的常量枚举
 */
export const enum GameInclusionConst {
  /** 通过游戏地址/下载地址提交 */
  gameUrl = 1,
  /** 包体本地上传 */
  packageUrl = 2
}

/**
 * @enum {number}
 * @description 出包类型的常量枚举
 */
export const enum GameTypeConst {
  /** ios */
  ios = 1,
  /** 安卓 */
  android = 2,
  /** h5 */
  h5 = 3,
  /** ios+安卓 */
  iosAndroid = 4
}

/**
 * @enum {number}
 * @description 游戏数值类型的常量枚举
 */
export const enum BtTypeConst {
  /** 常规版 */
  Normal = 1,
  /** 膨胀版 */
  Expansion = 2,
  /** bt版 */
  Bt = 3,
  /** 部分膨胀版 */
  PartialExpansion = 4,
  /** 免费版 */
  Free = 5,
  /** 福利版 */
  Welfare = 6,
  /** 其他版本 */
  Other = 7
}

/**
 * @enum {number}
 * @description 游戏包名是否已存在的常量枚举
 * 游戏包名是否已存在
 * 已存在：1；不存在：-1.
 */
export const enum IsExistConst {
  /** 已存在 */
  isExists = 1,
  /** 不存在 */
  noExist = -1
}

/**
 * @enum {string}
 * @description 游戏LOGO圆角弧度检测开关
 */
export const enum GameLogoRadiusConst {
  /** 开启 */
  Open = '1',
  /** 关闭 */
  Close = '-1'
}

/**
 * @enum {number}
 * @description 商城状态的常量枚举
 */
export const enum MallStatusConst {
  /** 0表示H5游戏，不存在 */
  NoExist0 = 0,
  /** 不存在 */
  NoExist1 = -1,
  /** 存在 */
  Exist = 1
}

export const enum NewListGameStatus {
  /** 未上线 */
  NotOnline = 1,
  /** 上线 */
  Online = 2,
  /** 下线 */
  Offline = 3,
  /** 停止对接 */
  StopDocking = 4
}

/**
 * @enum {string}
 * @description 商品货币的常量枚举 CNY:人民币,USD:美元,HKD:港币,VND:越南盾,KRW:韩元
 */
export const enum GameCurrencyConst {
  /** 人民币 */
  CNY = 'CNY',
  /** 美元 */
  USD = 'USD',
  /** 港币 */
  HKD = 'HKD',
  /** 越南盾 */
  VND = 'VND',
  /** 韩元 */
  KRW = 'KRW',
  /** 泰铢 */
  THB = 'THB',
  /** 日元 */
  JPY = 'JPY',
  /** 台币 */
  TWD = 'TWD'
}

/**
 * @enum {string}
 * @description 是否是实付结算【1：是；-1否】合作类型为专服且折扣类型选择不低于XX折才需要传该字段
 */
export const enum IsPaymentSettlementConst {
  /** 是 */
  Yes = '1',
  /** 否 */
  No = '-1'
}
